import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { GOOGLE_REVIEW_URL } from "../../lib/constants";

/** "Leave a Google review" card — renders nothing until GOOGLE_REVIEW_URL
 *  is configured in lib/constants.js. */
export const GoogleReviewCard = () => {
  if (!GOOGLE_REVIEW_URL) return null;
  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: "rgba(255,214,64,0.28)", background: "rgba(255,214,64,0.05)" }}
      data-testid="google-review-card"
    >
      <div className="flex items-start gap-3">
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
          style={{ background: "rgba(255,214,64,0.12)", border: "1px solid rgba(255,214,64,0.35)" }}
        >
          <Star className="w-4 h-4" style={{ color: "#FFD640" }} strokeWidth={2} />
        </div>
        <div className="flex-1">
          <div className="text-white text-sm font-semibold">Loving EVIQ?</div>
          <p className="text-zinc-400 text-xs leading-relaxed mt-0.5 mb-3">
            A 30-second Google review helps other Tesla owners find independent battery intelligence.
          </p>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-review-link"
            className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-bold text-black"
            style={{ background: "#FFD640" }}
          >
            Leave a Google review
            <ExternalLink className="w-3 h-3" strokeWidth={2.5} />
          </a>
        </div>
      </div>
    </div>
  );
};
